export const STANDARD_SYMBOL_MAPPING: Record<string, string> = {
    Resistor: "document_assets/fixed-resistor-us-9003be3c-a6c0-8314-d98f-a0a79124231c.svg",
    "Fixed Resistor": "document_assets/fixed-resistor-us-9003be3c-a6c0-8314-d98f-a0a79124231c.svg",
    Capacitor: "document_assets/non-polarized-cap-63916ae4-4e5c-14be-af86-277996818cfc.svg",
    "Non-Polarized Capacitor": "document_assets/non-polarized-cap-63916ae4-4e5c-14be-af86-277996818cfc.svg",
    "Polarized Capacitor": "document_assets/polarized-cap-37900753-12a8-31ba-520a-57d33f721c9b.svg",
    Inductor: "document_assets/inductor-53001199-68ae-2ee6-e124-07e5ad151659.svg",
    Diode: "document_assets/pn-diode-70c00119-f94a-c7a3-366d-fc5366fcc570.svg",
    LED: "document_assets/led-off-e3f35236-6e8b-23a3-f491-751d2f88cf9c.svg",
    "Ceramic Capacitor": "document_assets/non-polarized-cap-63916ae4-4e5c-14be-af86-277996818cfc.svg",
    "Film Capacitor": "document_assets/non-polarized-cap-63916ae4-4e5c-14be-af86-277996818cfc.svg",
    "Silicon Capacitor": "document_assets/non-polarized-cap-63916ae4-4e5c-14be-af86-277996818cfc.svg",
    "Electrolytic Capacitor": "document_assets/polarized-cap-37900753-12a8-31ba-520a-57d33f721c9b.svg",
    "Super-cap Capacitor": "document_assets/polarized-cap-37900753-12a8-31ba-520a-57d33f721c9b.svg",
    Ground: "document_assets/ground-420b199c-b591-be2b-99f1-088328ac6a43.svg",
    Antenna: "antenna-fbfac661-e562-f095-9591-586c8fa684ca.svg",
    Switch: "spst-switch-open-5840e219-0eab-cf67-6dab-9e43dcd1bf3b.svg",
    Relay: "document_assets/relay-off-5e60def9-837c-b6aa-cac8-38ff7eaa4456.svg",
    Transformer: "step-up-transformer-d72aafde-5b46-87da-cbd8-aab5368d1281.svg",
    "Variable Resistor": "potentiometer-45dbc4e3-09ec-74aa-b4dc-0c892202309b.svg",
};

export const STANDARD_SYMBOL_VARIANT_ASSET_PATHS = {
    "NPN Transistor": "document_assets/npn-transistor-595b16aa-2ec4-446b-b380-bb11e9844721.svg",
    "PNP Transistor": "document_assets/pnp-transistor-95828dac-9b83-4ee7-8bb4-ab3b18504c30.svg",
    "N-Channel MOSFET": "document_assets/n-channel-mosfet-baa37586-4941-492d-b5d1-7a9b7881850d.svg",
    "P-Channel MOSFET": "document_assets/p-channel-mosfet-d5a46230-993e-4551-8cea-bca0206cdfc8.svg",
    "N-Channel JFET": "document_assets/n-channel-jfet-ba4c6e89-da05-4b5e-8605-24a096683874.svg",
    "P-Channel JFET": "document_assets/p-channel-jfet-040c6ba2-c1b1-4223-a8e7-7541360736dc.svg",
    IGBT: "document_assets/igbt-7b0d1b81-d2a8-4e43-a4de-6b02cd2f47a2.svg",
    SCR: "document_assets/scr-33a3ec8c-e059-4826-a4bf-913f7da6a3ac.svg",
    Triac: "document_assets/triac-074317ad-9447-4c6f-8570-fc9600c08f86.svg",
    "Bridge Rectifier": "document_assets/bridge-rectifier-e341363d-4901-4193-81fd-7957d63da2d5.svg",
    "Op-Amp": "document_assets/op-amp-27bc02c5-24cc-4373-bfeb-0b2ba4c259c3.svg",
    Optocoupler: "document_assets/optocoupler-f7363d1a-cc3b-4455-a4ca-c00890808861.svg",
    "Optocoupler with Base": "document_assets/optocoupler-with-base-c6f163ec-4dec-4876-8d9a-d5ab3d3ebafb.svg",
} as const;
